import { Point } from '@lumapps/wrex/slate';
import { insertVoidBlock } from '@lumapps/wrex/slate/utils/insertVoidBlock';
import type { WrexEditor } from '@lumapps/wrex/types';

import { IframeEditor, IframeElement } from '../types';
import { createIframeElement } from './createIframeElement';

/**
 * Insert iframe element after editor selection.
 * Returns the final insert position of the node. Useful for targeting the inserted node.
 */
export function insertIframeElement(
    editor: WrexEditor<IframeEditor>,
    attributes: Omit<IframeElement, 'type' | 'children'>,
    point?: Point | undefined,
) {
    const node = createIframeElement(attributes);

    const path = insertVoidBlock(editor, node, point);

    return path;
}
